import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@mui/material'
import ImageBg from 'src/assets/Buy_Policy_Images/MotorFormBg.svg'
import Fade from '@mui/material/Fade'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import KuttiImage from 'src/assets/Buy_Policy_Images/KuttiImage.svg'
import guarantee from 'src/assets/Buy_Policy_Images/Gurantee.svg'
import CarDetailsTabs from './CarDetailsTabs'
import {
  BUY_CAR_INSURANCE_OPTION_TYPES,
  CAR_DETAILS_TAB_TYPES,
} from 'src/utils/constants/BuyPolicy'
import BrandSelector from './BrandSelector'
import CarTypeSelector from 'src/components/BuyPolicy/insuranceScreens/motor/BuyCarInsuranceModal/CarTypeSelector'
import FuelSelector from 'src/components/BuyPolicy/insuranceScreens/motor/BuyCarInsuranceModal/FuelSelector'
import RtoDetails from 'src/components/BuyPolicy/insuranceScreens/motor/BuyCarInsuranceModal/RtoDetails'
import Disclaimer from 'src/components/BuyPolicy/insuranceScreens/motor/BuyCarInsuranceModal/Disclaimer'
import ModelSelector from 'src/components/BuyPolicy/insuranceScreens/motor/BuyCarInsuranceModal/ModelSelector'
import PriceDetails from 'src/components/BuyPolicy/insuranceScreens/motor/BuyCarInsuranceModal/PriceDetails'
import { isNewCarInsuranceType } from 'src/utils/commonMethods/buyPolicy'
import ThankYouPage from 'src/components/BuyPolicy/insuranceScreens/motor/BuyCarInsuranceModal/ThankYouPage'
import UserDetails from 'src/components/BuyPolicy/insuranceScreens/motor/BuyCarInsuranceModal/UserDetails'

const BuyCarInsuranceModal = ({
  isInsuranceModalOpen,
  buyInsuranceType,
  handleClose,
}) => {
  const classes = useStyles()

  const [carDetails, setCarDetails] = useState({
    brand: null,
    carType: null,
    model: null,
    fuelType: null,
    rtoLocation: null,
    registrationDate: null,
    exShowroomPrice: null,
    userFullName: null,
    userMobileNumber: null,
    // userDetails: {
    //   fullName: '',
    //   mobileNumber: '',
    // },
  })

  const [selectedTab, setSelectedTab] = useState(CAR_DETAILS_TAB_TYPES?.brand)
  const [showDisclaimer, setShowDisclaimer] = useState(
    isNewCarInsuranceType(buyInsuranceType)
  )
  const [showThankYouPage, setShowThankYouPage] = useState(false)

  const handleTabChange = (tabDetails) => {
    setSelectedTab(tabDetails?.type)
  }

  const handleCarDetailsChange = (data) => {
    setCarDetails((carDetails) => ({
      ...carDetails,
      ...data,
    }))
    getNextTab()
  }

  const getNextTab = () => {
    switch (selectedTab) {
      case CAR_DETAILS_TAB_TYPES?.brand:
        setSelectedTab(CAR_DETAILS_TAB_TYPES?.car)
        break
      case CAR_DETAILS_TAB_TYPES?.car:
        setSelectedTab(CAR_DETAILS_TAB_TYPES?.fuel)
        break
      case CAR_DETAILS_TAB_TYPES?.fuel:
        setSelectedTab(CAR_DETAILS_TAB_TYPES?.model)
        break
      case CAR_DETAILS_TAB_TYPES?.model:
        setSelectedTab(CAR_DETAILS_TAB_TYPES?.rtoDetails)
        break
      case CAR_DETAILS_TAB_TYPES?.rtoDetails:
        if (buyInsuranceType === BUY_CAR_INSURANCE_OPTION_TYPES.newCar) {
          setSelectedTab(CAR_DETAILS_TAB_TYPES?.price)
        } else {
          setSelectedTab(CAR_DETAILS_TAB_TYPES?.userDetails)
        }
        break
      case CAR_DETAILS_TAB_TYPES?.price:
        setSelectedTab(CAR_DETAILS_TAB_TYPES?.userDetails)
        break
      case CAR_DETAILS_TAB_TYPES?.userDetails:
        break
      default:
        break
    }
  }

  const getSelectorComponent = () => {
    switch (selectedTab) {
      case CAR_DETAILS_TAB_TYPES?.brand:
        return (
          <BrandSelector
            carDetails={carDetails}
            handleBrandChange={handleCarDetailsChange}
          />
        )
      case CAR_DETAILS_TAB_TYPES?.car:
        return (
          <CarTypeSelector
            carDetails={carDetails}
            handleChange={handleCarDetailsChange}
          />
        )
      case CAR_DETAILS_TAB_TYPES?.fuel:
        return (
          <FuelSelector
            carDetails={carDetails}
            handleChange={handleCarDetailsChange}
          />
        )
      case CAR_DETAILS_TAB_TYPES?.model:
        return (
          <ModelSelector
            carDetails={carDetails}
            handleChange={handleCarDetailsChange}
          />
        )
      case CAR_DETAILS_TAB_TYPES?.rtoDetails:
        return (
          <RtoDetails
            carDetails={carDetails}
            handleChange={handleCarDetailsChange}
          />
        )
      case CAR_DETAILS_TAB_TYPES?.price:
        return (
          <PriceDetails
            carDetails={carDetails}
            handleChange={handleCarDetailsChange}
          />
        )
      case CAR_DETAILS_TAB_TYPES?.userDetails:
        return (
          <UserDetails
            carDetails={carDetails}
            buyInsuranceType={buyInsuranceType}
            onSubmit={handleSubmit}
          />
        )
      default:
        break
    }
  }

  // eslint-disable-next-line
  const handleSubmit = (data) => {
    // api call to submit details
    setShowThankYouPage(true)
  }

  const getTabbedComponents = () => {
    return showDisclaimer ? (
      <Disclaimer
        closeDisclaimer={() => setShowDisclaimer(false)}
        handleClose={handleClose}
      />
    ) : (
      <Box className={classes.formSectionMain}>
        <Box className={classes.tabSection}>
          <CarDetailsTabs
            carDetails={carDetails}
            buyInsuranceType={buyInsuranceType}
            selectedTab={selectedTab}
            onTabChange={handleTabChange}
          />
        </Box>
        <Box className={classes.contentSection}>
          <Box>
            <Box className={classes.closeIconContainer}>
              <IconButton onClick={handleClose} id='closeButton'>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box className={classes.active}>{getSelectorComponent()}</Box>

            <Box className={classes.imagesContainer}>
              <Box className={classes.secureContent}>Secure your</Box>
              <Box className={classes.kuttiImageContainer}>
                <Box className={classes.kuttiContainer}>
                  <img src={KuttiImage} alt='kutti' width={'100%'} />
                </Box>
                <Box className={classes.guaranteeImageContainer}>
                  <img src={guarantee} alt='Guarantee' width={'100%'} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <>
      <Fade in={isInsuranceModalOpen}>
        <Box className={classes.modalRoot}>
          {showThankYouPage ? (
            <ThankYouPage handleClose={handleClose} />
          ) : (
            getTabbedComponents()
          )}
        </Box>
      </Fade>
    </>
  )
}

export default BuyCarInsuranceModal

const useStyles = makeStyles({
  formSectionMain: {
    display: 'flex',
    backgroundImage: `url(${ImageBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom',
  },
  tabSection: {
    width: '30%',
    borderRight: '1px solid #ccc',
    background:
      'linear-gradient(192.92deg, #4DC3E3 -430.34%, rgba(255, 255, 255, 0) 94.64%)',
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    padding: '16px',
  },
  contentSection: {
    width: '70%',
  },
  closeIconContainer: {
    textAlign: 'right',
    right: '0',
    top: '0',
  },
  formCardTwo: {
    border: '1px solid #4DC3E3',
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    flexWrap: 'wrap',
    margin: '0px 20px',
  },
  formCardThree: {},
  formHeadingLabel: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0em',
    color: '#000000 !important',
  },
  formRadioText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '0em',
    marginLeft: '-8px',
  },
  imagesContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: 50,
    gap: 10,
  },
  secureContent: {
    fontFamily: 'Roboto',
    fontSize: '26px',
    fontWeight: 600,
    color: '#D7D7D7',
  },
  kuttiImageContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },
  guaranteeImageContainer: {
    zIndex: 2,
    position: 'absolute',
    left: '80%',
    top: '9%',
  },
  kuttiContainer: {
    zIndex: 1,
  },
  active: {
    opacity: 1,
  },
  errorStyle: {
    color: 'red !important',
  },
  radioButtonOptions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  detailsReadyText: {
    textAlign: 'center',
    paddingTop: 35,
  },
  modalRoot: {
    background: '#FFF',
    width: '65vw',
  },
})
